import React from "react";
import { useTranslation } from "react-i18next";
import cls from "./styles.module.scss";

type RafflePageLoaderProps = {
  isExiting?: boolean;
};

export const RafflePageLoader = ({ isExiting }: RafflePageLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={[cls.raffleLoader, isExiting ? cls.raffleLoaderExit : ""].join(
        " "
      )}
      role="status"
      aria-label={t("raffle.a11y.loading")}
    >
      <div className={cls.loaderStage}>
        <svg
          className={cls.loaderWheelSvg}
          width="164"
          height="164"
          viewBox="0 0 164 164"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g className={cls.loaderWheelSpin}>
            <circle cx="82" cy="82" r="76" fill="var(--palette-red-500)" />
            <circle cx="82" cy="82" r="70" fill="white" />
            <path
              d="M82 82L82 17A65 65 0 0 1 123.781 32.208Z"
              fill="var(--palette-green-500)"
            />
            <path
              d="M82 82L123.781 32.208A65 65 0 0 1 146.012 70.712Z"
              fill="var(--palette-red-500)"
            />
            <path
              d="M82 82L146.012 70.712A65 65 0 0 1 138.292 114.5Z"
              fill="#C58B3E"
            />
            <path
              d="M82 82L138.292 114.5A65 65 0 0 1 104.231 143.079Z"
              fill="var(--palette-green-500)"
            />
            <path
              d="M82 82L104.231 143.079A65 65 0 0 1 59.769 143.079Z"
              fill="var(--palette-red-500)"
            />
            <path
              d="M82 82L59.769 143.079A65 65 0 0 1 25.7083 114.5Z"
              fill="#C58B3E"
            />
            <path
              d="M82 82L25.7083 114.5A65 65 0 0 1 17.9885 70.712Z"
              fill="var(--palette-green-500)"
            />
            <path
              d="M82 82L17.9885 70.712A65 65 0 0 1 40.2188 32.208Z"
              fill="var(--palette-red-500)"
            />
            <path d="M82 82L40.2188 32.208A65 65 0 0 1 82 17Z" fill="#C58B3E" />
            <circle
              cx="82"
              cy="82"
              r="65"
              stroke="rgba(255, 255, 255, 0.28)"
              strokeWidth="1"
            />
            <circle cx="82" cy="82" r="20" fill="#FCBD00" />
            <circle cx="76" cy="75" r="8" fill="white" fillOpacity="0.78" />
          </g>
          <path
            className={cls.loaderPin}
            d="M82 24L68 -1H96L82 24Z"
            fill="white"
          />
        </svg>
      </div>
      <div className={cls.loaderCaption}>
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};
